export const config = {
    baseUrl: '/api',
    imageUrl: '/images',
    fileUrl: '',
};
